// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"3b92d052","224":"2fe12526","354":"8a7c48b0","360":"481be4d7","370":"2de68859","509":"a624418f","637":"8b5356f6","647":"ab753d82","679":"cf66ae17","682":"a0f257b7","791":"3f20383a","793":"89a95c7f","890":"eb6050c2"}[chunkId] + ".chunk.js";
};